import { useGenerateChargebeePortalMutation as useGenerateChargebeePortal } from '../types'
export default useGenerateChargebeePortal
